import { IAbcComponent } from '../abcComponent.model';

export interface INotification extends IAbcComponent {
  message: string;
  type?: ToastType;
  displayTime?: number;
  position?: Object;
  animation?: Object;
  closeOnOutsideClick?: boolean;
  setNotificationStyle?(style?: NotificationStyle);
}
export enum ToastType {
  Custom = 'custom',
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
}
export class NotificationStyle {
  width: string | number;
  height: string | number;
}
